let mutations = {
    setAllAnswer(state, data) {
        state.mAnswers = data;
    },
    setmAnswerModel(state, data) {
        let index = data.index;
        state.mAnswers[index] = data;

    },
    clearMAnswer(state) {
        state.mAnswers = [];
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/mAnswerModel/mutations.js